import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles/header.css';

interface IHeaderProps {
  title?: string;
  basic?: boolean;
  padded?: boolean; // 16px
  centered?: boolean;
  children?: React.ReactNode;
  veryPadded?: boolean; // 20px
}

export function Header(props: IHeaderProps) {
  const { basic = false, padded = false, veryPadded = false, centered = false, children, title } = props;

  return (
    <div
      className={cx(
        styles['header'],
        basic && styles['basic'],
        padded && styles['padded'],
        centered && styles['centered'],
        veryPadded && styles['very_padded'],
      )}
    >
      {title || children}
    </div>
  );
}
